import { Injectable } from "@angular/core";
import { ActivatedRoute, ParamMap } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

import { MenuSubMenu } from '../shared/menu/menu-sub-menu.model';
import { Menu } from '../shared/menu/menu.model';
import { MenuParameters } from './menu-parameters.model';
import { MenuService } from '../shared/header/menu/menu.service';
import { LanguageService } from '../core/language/language.service';


@Injectable({
    providedIn: 'root'
})
export class FullMenuService {

    private menu$: BehaviorSubject<MenuParameters> = new BehaviorSubject<MenuParameters>(new MenuParameters(null, null, null));
    private selectedMenuCategory$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private selectedSortType$: BehaviorSubject<string> = new BehaviorSubject<string>('views');
    private menuParameters: MenuParameters;
    private menuList: Array<Menu>;
    private sortType: string;

    /*CSCSATIVA-5528 - Navegação via Tab menu e categorias*/
    private selectedTabindexMenu$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
    private selectedTranslationKeyCategory$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private tabindexMenu: number;
    private selectedTranslationKeyCategory:string;

    constructor(private route: ActivatedRoute, private menuService: MenuService, private languageService: LanguageService) {
        
        this.menuParameters = new MenuParameters(null, null, null);
        this.menuService.getMenu().subscribe((menuList: Array<Menu>) => {
            this.menuList = menuList;
            this.filterMenuByCategory(this.menuParameters.name);
        });
    }

    getSortType(): Observable<string> {

        return this.selectedSortType$.asObservable();
    }

    setSortType(sortType: string) {
        if (!(sortType.trim() === 'views') && !(sortType.trim() === 'name'))
            throw new Error("Invalid parameter supplied to sortType");
        this.sortType = sortType;
        this.selectedSortType$.next(sortType);
    }

    getCurrentMenuOptions() {

        return this.selectedMenuCategory$.asObservable();
    }

  
    getMenuTabindex() {
        return this.selectedTabindexMenu$.asObservable();
    }

    setMenuTabindex(tabindexMenu:number) {        
        this.tabindexMenu = tabindexMenu;
        this.selectedTabindexMenu$.next(tabindexMenu);
    }

    getSelectedTranslationKeyCategory() {
        return this.selectedTranslationKeyCategory$.asObservable();
    }

    setSelectedTranslationKeyCategory(selectedTranslationKeyCategory:string) {        
        this.selectedTranslationKeyCategory = selectedTranslationKeyCategory;
        this.selectedTranslationKeyCategory$.next(selectedTranslationKeyCategory);
    }


    /**
     * Método para recuperação de parâmetros da URL 
     * @param route o ActivatedRoute do qual deseja se extrair os parâmetros
     * @param desiredParams array de strings com os nomes dos parâmetros desejados
     */
    filterMenuThroughURLParameters(route: ActivatedRoute): Observable<MenuParameters> {

        route.paramMap.subscribe((params: ParamMap) => {
            let menuName = params.get('menuName');
            let menuCategory = params.get('category');
            this.menuParameters.name = this.capitalizeString(menuName);
            this.menuParameters.category = this.capitalizeString(menuCategory);

            this.filterMenuByCategory(menuName);
        });
        return this.menu$.asObservable();
    }

    public filterMenuThroughParameters(menuName: string, menuCategory: string): Observable<MenuParameters> {
        this.menuParameters.name = this.capitalizeString(menuName);
        this.menuParameters.category = this.capitalizeString(menuCategory);
        this.filterMenuByCategory(menuName);
        return this.menu$.asObservable();
    }

    getSelectedMenu(menuName: string): Menu {
        if (!this.menuList || !menuName)
            return;

        return [...this.menuList].filter(menuCategory => menuCategory.name.toLowerCase() === (!menuName ? menuCategory.name.toLowerCase() : menuName.toLowerCase()))[0];
    }

    filterMenuByCategory(menuName: string): void {

        let selectedMenu: Menu = this.getSelectedMenu(menuName);
        if (selectedMenu) {
            this.menuParameters.menu = selectedMenu;
            this.selectedMenuCategory$.next(selectedMenu.categories);
            this.menu$.next(this.menuParameters);
        }
    }
        
    sortMenu(unsortedOptions:  Array<MenuSubMenu>) {
        if  (!this.sortType  ||  this.sortType  ===  "views") {
            unsortedOptions  =  [...unsortedOptions].sort(
                (t1,  t2)  => { 
                    if(t1.timesViewed > t2.timesViewed) {return -1;}
                    if(t1.timesViewed < t2.timesViewed) {return 1;}
                    return 0;
                });
        }
        else {
            unsortedOptions = [...unsortedOptions].sort((t1, t2) => {
                const subCategory1 = t1.subCategory;
                const subCategory2 = t2.subCategory;
                if (!subCategory1) { return -1; }
                if (subCategory1 > subCategory2) { return 1; }
                if (subCategory1 < subCategory2) { return -1; }
                return 0;
            });
            unsortedOptions = [...unsortedOptions].sort((t1, t2) => {
                
                const name1 = this.languageService.translate(t1.translationKey).toLowerCase();
                const name2 = this.languageService.translate(t2.translationKey).toLowerCase();
                
                if (t1.subCategory === t2.subCategory) {
                    return name1.localeCompare(name2);
                }
                return  0;
            });
            
        }
        return  unsortedOptions;
    }


    private capitalizeString(text: string): string {

        if (!text)
            return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}